import React, { useState } from "react";
import { PageHeader } from "antd";

import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";

import { useEffect } from "react";
import { useParams } from "react-router-dom";
import PhysicallFitnessEnrollmentEntryMonthly from "../../components/enrollment/physicallfitness/PhysicallFitnessEnrollmentEntryMonthly";

const PhysicallFitnessEnrollmentMonthly = () => {
  const params = useParams();
  const [heading,setHeading] = useState("");

  useEffect(()=>{
    if(params.billtype){
      params.billtype == "gst" ? setHeading("Monthly Subscription Physicall Fitness (GST)") : setHeading("Monthly Subscription Physicall Fitness (NON-GST)");
    }
  },[params.billtype]);
 

  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title={heading}
          subTitle=""
          extra={[]}
        ></PageHeader>

        <PhysicallFitnessEnrollmentEntryMonthly />
      </div>
    </div>
  );
};

export default PhysicallFitnessEnrollmentMonthly;
